/* ONE 1 Hz tick, for everything that has to keep up with the clock.
 *
 * The tide sheet's curve, the current rose, the tideline's "+1h20" and the
 * layers panel's live descriptions all need to re-read once a second. Before
 * the shell they each owned a `setInterval` — five of them, started and stopped
 * on five different mount lifecycles, and the layers panel's comment explains
 * at length why it had to have its own.
 *
 * `<Chart>` already sweeps at 1 Hz and calls `tick`. This is where that lands,
 * so a panel asks for the number instead of setting a timer.
 */
class Pulse {
  n = $state(0);
  bump(): void {
    this.n++;
  }
}

export const pulse = new Pulse();
